import { SideBarContext, SideBarContextModel } from '@contexts/sidebar-context';
import { useContext } from 'react';

export function useSideBar(): SideBarContextModel {
    return useContext(SideBarContext);
}
